import AmsterdamHotel1 from '../Assets/Images/amsterdam-hotel1.jpg';
import LondonHotel1 from '../Assets/Images/london-hotel1.jpg';
import FranceHotel1 from '../Assets/Images/france-hotel1.jpg';
import AmsterdamHotel4 from '../Assets/Images/amsterdam-hotel4.jpg';
import LonodnHotel2 from '../Assets/Images/london-hotel2.jpg';
import FranceHotel4 from '../Assets/Images/france-hotel4.jpg';

let EuropeDestinationsItems = [
    {
        id: 1,
        itemImage: AmsterdamHotel1,
        itemTitle: 'Canal House Boutique Stay',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '5 nights',
        itemPrice: '£799'
    },
    {
        id: 2,
        itemImage: LondonHotel1,
        itemTitle: 'Central London Luxury Stay',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '7 nights',
        itemPrice: '£1399'
    },
    {
        id: 3,
        itemImage: FranceHotel1,
        itemTitle: 'Parisian Balcony Hotel',
        itemSubTitle: 'Paris, France',
        itemNights: '6 nights',
        itemPrice: '£999'
    },
    {
        id: 4,
        itemImage: AmsterdamHotel4,
        itemTitle: 'Modern Riverside Hotel',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '6 nights',
        itemPrice: '£1399'
    },
    {
        id: 5,
        itemImage: LonodnHotel2,
        itemTitle: 'Urban Boutique City Stay',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '5 nights',
        itemPrice: '£999'
    },
    {
        id: 6,
        itemImage: FranceHotel4,
        itemTitle: 'Charming Left Bank Stay',
        itemSubTitle: 'Paris, France',
        itemNights: '5 nights',
        itemPrice: '£799'
    }
];

export default EuropeDestinationsItems;
